import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router';

class LodgingWidget extends React.Component {
  render() {
    if (this.props.tour.groups.length == 0 || this.props.tour.tour_stops.length == 0) {
      return null;
    }
    const lodgingUrl = `/tours/${this.props.tour.id}/hotels`;
    return (
      <div className="col-sm-4">
        <Panel header="Lodging">
          <div className="tour-today text-center">
            <Link to={lodgingUrl} >Book Hotels</Link>
          </div>
        </Panel>
      </div>
    );
  }
}
export default LodgingWidget;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/LodgingWidget.js